export default {
  uCurricular: {},
  uCurriculars: [],
  fields: {},
  errorArray: [],
  dialog: false,
};
